import axios from "axios";

const client = axios.create({
    baseURL: import.meta.env.VITE_APP_BELOZ_V2_ENDPOINT,
});

export const saveExternalProviderRequestService = async (
    authToken,
    requestBody,
) => {
    try {
        const { data } = await client.post(
            '/external/external-provider-request',
            {
                ...requestBody,
            },
            {
                headers: {
                    Authorization: `Bearer ${authToken}`,
                },
            },
        );
        return {
            success: data.success,
        };
    } catch (error) {
        console.log('saveExternalProviderRequestService', error);
        return {
            success: false,
        };
    }
};